<template>
  
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-form ref='form' :model='search' :initialValues="search" style="margin-bottom: 25px;" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="关键词" >
              <a-input v-model:value="search.keyword"  placeholder="请输入关键词进行搜索"/>
        </a-form-item>
        <a-form-item label="推荐经销商" >
              <a-input v-model:value="search.dealer_name"  placeholder="请输入推荐经销名称"/>
        </a-form-item>
        <a-form-item label="所属上级" name='dealer_id'>
          <a-input v-model:value="search.up_dealer" readonly  placeholder='请选择上级经销商'></a-input>
          <CloseCircleFilled class="fz-14 s_c999" style="position: absolute;right: 5px;top: 50%;transform:translateY(-50%)" v-if='search.up_dealer' @click='search.up_dealer="";search.parent_dealer_id=""' />
        </a-form-item>

        <a-form-item>
             <a-button type="primary" @click='showDealer = true'>选择</a-button>
        </a-form-item>
      
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" ghost v-has:extensionExport="()=>{exportTable()}">导出</a-button>
        </a-form-item>
       
      </a-form>
      <a-table  :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data' class="tableFixBox"></a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" />
    </a-card>
  </a-layout>
  <a-modal  :keyboard="false" title="选择上级经销商" centered v-model:visible="showDealer" :width='1000' :footer="null" destroyOnClose>
    <selectDealer v-on:select="dealerSelect" :id='search.parent_dealer_id' :selectList='[{dealer_id:search.parent_dealer_id}]' :checkout="false" :mustShowHeadquarters='true'></selectDealer>
  </a-modal>
</template>
<script>
import { CloseCircleFilled } from "@ant-design/icons-vue";
import { ref, onMounted,inject,reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
// import { getRouter } from "@/utils/app";
// import { setPageState, getPageState } from "@/utils/pageState";
import { extensionList } from "@/api/dealer";
import { iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defSearch = {
  keyword: "",
  page: 1,
  limit: 10,
  parent_dealer_id:'',
  dealer_name:'', 
  up_dealer:'',
  excel:''
};
export default {
 components:{CloseCircleFilled},
  setup(props, ctx) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      showDealer:false,
      open:false,
      listLoading: false,
      time:[],
      total: 1,
      selectedRowKeys:[],

    });
    let columns = [
      {
        title: "经销商编号",
        dataIndex: "dealer_sn",
        key: "dealer_sn",
        width:120
      },
      {
        title: "经销商名称",
        dataIndex: "dealer_name",
        key: "dealer_name",
        
      },
      {
        title: "推荐经销商",
        dataIndex: "extension_dealer_name",
        key: "extension_dealer_name"
      },
      {
        title: "所属上级",
        dataIndex: "parent_name",
        key: "parent_name"
      }
    ];
    const $router = inject('$router')
    const $Modal = inject('$Modal')

    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    
    //选择经销商
    const dealerSelect = (e) => {
          if(e == 0){
            search.value.up_dealer = "总部";
            search.value.parent_dealer_id = 0;
          }else{
            search.value.up_dealer = e.dealer_name || "";
            search.value.parent_dealer_id = e.dealer_id || null;
          }
        state.showDealer = false;
      }
   
    const initData = async (values)=>{
      state.listLoading = true;
        data.value = []
         let result = await extensionList(values).then(res=>res.data)
         state.listLoading = false;
          if (iscode(result)) {
            data.value = result.data.data;
            state.total = result.data.total;
          } else {
            message.error(result.msg);
          }
    }
    
    onMounted(() => {
      initData(search.value);
    });
                    // 导出
    const exportTable=async ()=>{
        let res = await extensionList({...search.value,excel:1}).then(res=>res.data);
        if(iscode(res,true)){
          window.open(res.data.action)
        }
    }
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      dealerSelect,
      exportTable
    };
  },
};
</script>